var _polyline, _path, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashR({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#EF466F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-trash-2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "3 6 5 6 21 6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 11,
    x2: 10,
    y2: 17
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 11,
    x2: 14,
    y2: 17
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashR);
export default __webpack_public_path__ + "static/media/trashR.0bfb746871a1ed6f387cf5b1c332a9b5.svg";
export { ForwardRef as ReactComponent };